module.exports = __webpack_public_path__ + "img/profile-active.8e9a3094.svg";